import React from 'react';

import {cn} from '../lib/helpers';

import {secondary, muted, buttonStyle} from './button.module.css';

const Button = ({
  children,
  as: As = 'a',
  target = 'https://app.urakkadiili.fi/tarjouspyynnot/uusi',
  variant,
  className,
  appJobTypes,
  rel = 'nofollow',
  ...rest
}) => {
  let variantClassName = null;
  switch (variant) {
    case 'secondary':
      variantClassName = secondary;
      break;
    case 'muted':
      variantClassName = muted;
      break;
    default:
      variantClassName = null;
  }

  let href = null;

  if (appJobTypes) {
    var params = [];
    appJobTypes.forEach((item) => {
      params.push(item.value);
    });

    href =
      'https://app.urakkadiili.fi/tarjouspyynnot/uusi?jobTypes=' +
      params.join();
  } else if (target) {
    href = target;
  }

  if (As === 'button') href = null;

  return (
    <As
      href={href}
      className={cn(
        buttonStyle,
        variant && variantClassName,
        className && className
      )}
      rel={rel}
      {...rest}
    >
      {children}
    </As>
  );
};

export default Button;
